import React from 'react';
import { gql } from 'react-apollo';
import graphqlWithoutCache from '../graphqlWithoutCache';

const {
  REACT_APP_CLOUDINAY_CLOUD_NAME,
} = process.env;
const logo = require('../../../images/encouragex-primary-logo.svg');
const bulb = require('../../../images/icon-lightbulb.svg');

function Footer(props) {
  const { loading, documentBySlug } = props.data;

  if (loading && !documentBySlug) {
    return null;
  }

  const documentLink = documentBySlug && documentBySlug.file
    ? `http://res.cloudinary.com/${REACT_APP_CLOUDINAY_CLOUD_NAME}/image/upload/${documentBySlug.file}`
    : '';

  return (
    <div className="footer">
      <img className="footer-logo" src={logo} alt="encouragex" />
      { documentBySlug && documentBySlug.file ?
        <div className="footer-text">
          <img className="footer-bulb" src={bulb} alt="bulb" />
          <span className="footer-question" >New to the platform?</span>
          <a target="_blank" className="footer-link" href={documentLink} >
            <span className="footer-link">Download our Getting Started Guide</span>
          </a>
        </div>
        : null
      }
    </div>
  );
}

function FooterWithData(props) {
  const documentQuery = gql`
  query documentBySlug($slug: String!){
    documentBySlug(slug: $slug) {
      file
    }
  }
  `;
  const Component = graphqlWithoutCache(documentQuery, {
    options: { variables: { slug: 'guide' } },
  })(Footer);

  return <Component {...props} />;
}

export default FooterWithData;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/Footer.js